export default "__VITE_ASSET__Cg5CRLJ4__"